import './CollectionEffectivenessIndex.scss';
import { TableUtility } from '@utility/dynamic-table';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import PropTypes from 'prop-types';
import { useCollectionReport } from '../../../Hooks/useCollectionReport';
import { MIS_COLLECTION_REPORT } from '../../../Constants/strings';

const CollectionEffectivenessIndex = ({ baseURL, createDownloadAllHandler }) => {
  const { empDetails } = useCollectionReport();
  const configuration = {
    generalSettings: {
      enableApiFiltering: true,
      showPagination: false,
      baseURL,
      userInfo: empDetails,
      apiEndpoints: {
        getFilteredData: {
          endpoint: 'collection-effectiveness-index',
          enabled: true,
        },
        download: {
          endpoint: 'collection-effectiveness-index/download',
          enabled: true,
        },
      },
      handler: {
        setDownloadDataHandler: (handler) => {
          createDownloadAllHandler(
            MIS_COLLECTION_REPORT.COLLECTION_EFFECTIVENESS_INDEX,
            handler,
          );
        },
      },
      headers: {
        'Content-Type': 'application/json',
        token: empDetails.access_token,
      },
    },
    showToolBar: false,
    tableSettings: {
      size: 'small',
      loaderSkeleton: {
        rows: 7,
        bodyCells: 1,
        columns: 5,
      },
      tableScrollHeight: '100%',
      maxFrozenColumns: {
        desktop: 1,
        tablet: 1,
        mobile: 1,
      },
    },
  };
  return (
    <div className="sub-table-five">
      <TableUtility configuration={configuration} />
    </div>
  );
};

CollectionEffectivenessIndex.propTypes = {
  baseURL: PropTypes.string.isRequired,
  createDownloadAllHandler: PropTypes.func.isRequired,
};

export default CollectionEffectivenessIndex;
